import { render, staticRenderFns } from "./ListContactModal.vue?vue&type=template&id=35761144"
import script from "./ListContactModal.vue?vue&type=script&lang=ts"
export * from "./ListContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports